/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiChip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20.558 17.39 23 19l-2.442 1.61L19 23l-1.559-2.39L15 19l2.441-1.61L19 15zm-2.01 1.2-.137.09-.485.32.485.32.138.09.451.692.451-.692.622-.41-.622-.41-.451-.692z" />
        <path d="M7 4h2V2h2v2h2V2h2v2h2V2h2v2h1v1h2v2h-2v2h2v2h-2v2h2v1h-4V6H6v12h8v4h-1v-2h-2v2H9v-2H7v2H5v-2H4v-1H2v-2h2v-2H2v-2h2v-2H2V9h2V7H2V5h2V4h1V2h2z" />
        <path d="M16 16H8V8h8zm-6-2h4v-4h-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiChip as AiChip };
